export { UserEntity } from './user-entity';

export type { Entity as UserEntityType } from './user-entity';
